import _get from 'lodash/get';

export const getVariablesForDataSource = (state, dataSourceId) => _get(state, `dataSourceVariables.${dataSourceId}`);
